import _ from 'lodash';
import BaseLocation from '../namespaces/location';
import * as postMessage from '../privates/postMessage';
import {validate} from '../privates/validations/validation';
import {generateError} from '../privates/validations/errors';
import reporter from '../privates/reporter';
import * as members from '../privates/privateMembers';

const isExternalLink = (linkData) => _.get(linkData, 'type') === 'ExternalLink';

class Location extends BaseLocation {
    constructor(appDefId) {
        super(appDefId);
        _.bindAll(this, ['navigateTo']);
    }

    getExternalUrl(linkData) {
        if (isExternalLink(linkData)) {
            return linkData.url;
        }
    }

    navigateTo(linkData) {
        if (!validate({compType: 'Location', functionName: 'navigateTo', dataToValidate: {linkData}})) {
            return;
        }
        if (isExternalLink(linkData)) {
            reporter.reportSdkError(generateError.error_navigating_to_external_url({externalUrl: linkData.url}));
            return;
        }

        if (linkData.hasOwnProperty('pageId')) {
            linkData.pageId = linkData.pageId === '#' ? linkData.pageId : linkData.pageId.replace('#', '');
        }

        if (linkData.hasOwnProperty('target')) {
            delete linkData.target;
        }

        postMessage.sendMessageToHost(postMessage.Intent.WIX_CODE_SITE_API, {
            command: postMessage.MessageTypes.NAVIGATE_TO,
            appDefinitionId: members._appDefId.get(this),
            data: linkData
        });
    }
}

export default Location;
